<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0.901514C0 0.182688 0.801131 -0.246064 1.39923 0.152669L8.32673 4.771C8.86109 5.12724 8.86109 5.91245 8.32673 6.26869L1.39923 10.887C0.801132 11.2858 0 10.857 0 10.1382V0.901514Z" fill="white"/>
</svg>
